/* eslint-disable react/prop-types */
import ComposedViewFiveComponent from "./composed-view-five";
import { useHistory } from "react-router-dom";
function ComposedViewFive({ title, content, button, onCLick, className }) {
  const history = useHistory();
  const handleClick = () => {
    let path = button.link;
    history.push(path);
  };

  return (
    <ComposedViewFiveComponent
      title={title}
      content={content}
      button={button}
      className={className}
      onClick={onCLick ? onCLick : handleClick}
    />
  );
}

export default ComposedViewFive;
